module.exports = __webpack_public_path__ + "static/media/sad-phone.bdc884eb.svg";